import React from "react";

// variant: "dark" (dark letters, for light backgrounds) | "light" (cream letters, for dark backgrounds)
export const Logo = ({ variant = "dark", className = "h-10", ...props }) => {
  const src = variant === "light" ? "/brand/logo-light.png" : "/brand/logo-dark.png";
  return (
    <img
      src={src}
      alt="Salty Folks Surf Club"
      className={className}
      draggable={false}
      {...props}
    />
  );
};
